company-questionnaire {
  display: block;

  label {
    display: block;
  }

  .company-questionnaire__range {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
}
